
namespace SorAraBul.Definitions {
    export class RestrictionsColumns {
        static columnsKey = 'Definitions.Restrictions';
    }
}